import { render, staticRenderFns } from "./ModerationFiltersForm.vue?vue&type=template&id=41da0ead&scoped=true&"
import script from "./ModerationFiltersForm.vue?vue&type=script&lang=js&"
export * from "./ModerationFiltersForm.vue?vue&type=script&lang=js&"
import style0 from "./ModerationFiltersForm.vue?vue&type=style&index=0&id=41da0ead&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41da0ead",
  null
  
)

export default component.exports